import { explicitMaybe } from '@execonline-inc/decoders';
import { array, boolean, date, Decoder, fail, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../Resource/Decoders';
import {
  AccessSource,
  AvailableCollection,
  AvailableLicense,
  NewGroupPayload,
  NewGroupResource,
} from './Types';

const accessSourceDecoder: Decoder<AccessSource> = string.andThen((s) =>
  s === 'organization' || s === 'client_group' || s === 'private'
    ? succeed<AccessSource>(s)
    : fail(`Invalid access_source: ${s}`),
);

const availableCollectionDecoder: Decoder<AvailableCollection> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('experiencesCount', field('experiences_count', number))
  .assign('selected', field('selected', boolean))
  .assign('accessSource', field('access_source', accessSourceDecoder));

const availableLicenseDecoder: Decoder<AvailableLicense> = succeed({})
  .assign('id', field('id', number))
  .assign('licenseName', field('license_name', explicitMaybe(string)))
  .assign('licenseTypeName', field('license_type_name', string))
  .assign('quantityAvailable', field('quantity_available', number))
  .assign('startOn', field('start_on', date))
  .assign('endOn', field('end_on', date))
  .assign('selected', field('selected', boolean));

const newGroupPayloadDecoder: Decoder<NewGroupPayload> = succeed({})
  .assign('learningCollections', field('learning_collections', array(availableCollectionDecoder)))
  .assign('productLicenses', field('product_licenses', array(availableLicenseDecoder)));

export const newGroupResourceDecoder: Decoder<NewGroupResource> =
  resourceDecoder(newGroupPayloadDecoder);
